import { _mock } from './_mock';

// ----------------------------------------------------------------------

export const WORK_ORDER_PRIORITY_OPTIONS = [
  { value: 'low', label: 'Low' },
  { value: 'medium', label: 'Medium' },
  { value: 'high', label: 'High' },
  { value: 'critical', label: 'Critical' },
];

export const WORK_ORDER_STATUS_OPTIONS = [
  { value: 'open', label: 'Open' },
  { value: 'in-progress', label: 'In Progress' },
  { value: 'pending', label: 'Pending' },
  { value: 'completed', label: 'Completed' },
  // { value: 'cancelled', label: 'Cancelled' },
];

export const WORK_ORDER_TYPE_OPTIONS = [
  // { value: 'preventive', label: 'Preventive Maintenance' },
  { value: 'corrective', label: 'Corrective Maintenance' },
  { value: 'emergency', label: 'Emergency Repair' },
  { value: 'inspection', label: 'Inspection' },
  { value: 'upgrade', label: 'Upgrade' },
];

// ----------------------------------------------------------------------

export const _workOrders = Array.from({ length: 24 }, (_, index) => {
  const status = WORK_ORDER_STATUS_OPTIONS[index % WORK_ORDER_STATUS_OPTIONS.length].value;
  const priority = WORK_ORDER_PRIORITY_OPTIONS[index % WORK_ORDER_PRIORITY_OPTIONS.length].value;
  const type = WORK_ORDER_TYPE_OPTIONS[index % WORK_ORDER_TYPE_OPTIONS.length].value;

  return {
    id: _mock.id(index),
    workOrderNumber: `WO-${String(index + 1000).padStart(6, '0')}`,
    title: [
      'HVAC System Maintenance',
      'Elevator Inspection',
      'Fire Safety System Check',
      'Electrical Panel Repair',
      'Plumbing Leak Fix',
      'Security Camera Installation',
      'Generator Maintenance',
      'Roofing Repair',
      'Lighting System Upgrade',
      'Door Lock Replacement',
      'Window Seal Repair',
      'Floor Cleaning Equipment Service',
      'Emergency Exit Light Check',
      'Water Heater Maintenance',
      'Air Conditioning Repair',
      'Flooring Replacement',
      'Paint Touch-up',
      'Network Equipment Check',
      'Parking Lot Maintenance',
      'Landscaping Service',
      'Fence Repair',
      'Signage Installation',
      'Waste Management System',
      'Solar Panel Cleaning',
    ][index % 24],
    description: [
      'Routine maintenance and inspection of HVAC system including filter replacement and system calibration.',
      'Monthly elevator safety inspection and mechanical systems check.',
      'Quarterly fire safety system inspection including alarms, sprinklers, and emergency exits.',
      'Repair electrical panel issues and ensure proper grounding and safety compliance.',
      'Fix plumbing leak in restroom facilities and check for additional damage.',
      'Install new security cameras in parking area with network configuration.',
      'Scheduled generator maintenance including oil change and battery check.',
      'Repair roof damage from recent storm and inspect for additional issues.',
      'Upgrade lighting system to LED fixtures for energy efficiency.',
      'Replace malfunctioning door locks with new electronic access system.',
      'Repair window seals to prevent water infiltration and improve insulation.',
      'Service floor cleaning equipment and replace worn parts.',
      'Monthly check of emergency exit lighting and battery backup systems.',
      'Annual water heater maintenance including sediment removal and safety check.',
      'Repair air conditioning unit that is not cooling effectively.',
      'Replace damaged flooring in high-traffic areas with durable materials.',
      'Touch-up paint in common areas and address wall damage.',
      'Check network equipment for proper operation and security updates.',
      'Repair potholes and restripe parking lot markings.',
      'Seasonal landscaping maintenance including pruning and fertilization.',
      'Repair fence damage and ensure security perimeter is intact.',
      'Install new wayfinding signage throughout the facility.',
      'Maintenance of waste management system and container replacement.',
      'Clean solar panels and inspect for damage or efficiency issues.',
    ][index % 24],
    status,
    priority,
    type,
    assetId: _mock.id(index + 100),
    assetName: [
      'HVAC Unit #1',
      'Passenger Elevator A',
      'Fire Alarm System',
      'Main Electrical Panel',
      'Restroom Plumbing',
      'Security System',
      'Emergency Generator',
      'Building Roof',
      'Lighting System',
      'Main Entrance Doors',
      'Window Assembly',
      'Floor Cleaning Equipment',
      'Emergency Lighting',
      'Water Heater #1',
      'AC Unit #3',
      'Lobby Flooring',
      'Interior Walls',
      'Network Infrastructure',
      'Parking Lot',
      'Landscape Areas',
      'Security Fence',
      'Building Signage',
      'Waste Management',
      'Solar Panel Array',
    ][index % 24],
    assignedTo: _mock.fullName(index),
    requester: _mock.fullName(index + 10),
    requestedDate: _mock.time(index),
    scheduledDate: _mock.time(index + 1),
    completedDate: status === 'completed' ? _mock.time(index + 2) : null,
    estimatedHours: [2, 4, 6, 8, 1, 12, 3, 16, 4, 2, 6, 3, 1, 8, 6, 12, 4, 2, 8, 6, 4, 3, 2, 4][
      index % 24
    ],
    actualHours:
      status === 'completed'
        ? [
            2.5, 3.8, 7.2, 8.5, 1.2, 11.5, 3.5, 15.8, 4.2, 2.1, 5.8, 3.2, 1.1, 7.5, 6.3, 12.8, 4.5,
            2.3, 8.2, 6.1, 4.3, 3.1, 2.2, 4.1,
          ][index % 24]
        : null,
    cost: [
      150, 200, 300, 450, 75, 800, 250, 1200, 350, 120, 180, 90, 50, 400, 280, 900, 200, 100, 600,
      250, 300, 150, 80, 200,
    ][index % 24],
    location: [
      'Building A - Mechanical Room',
      'Building A - Lobby',
      'Building A - All Floors',
      'Building A - Electrical Room',
      'Building A - 2nd Floor Restroom',
      'Building A - Parking Area',
      'Building A - Generator Room',
      'Building A - Roof',
      'Building A - Common Areas',
      'Building A - Main Entrance',
      'Building A - East Wing',
      'Building A - Maintenance Room',
      'Building A - Emergency Exits',
      'Building A - Basement',
      'Building A - 3rd Floor',
      'Building A - Lobby',
      'Building A - Common Areas',
      'Building A - IT Room',
      'Building A - Parking Lot',
      'Building A - Exterior',
      'Building A - Perimeter',
      'Building A - Entrance',
      'Building A - Loading Dock',
      'Building A - Roof',
    ][index % 24],
    notes: '',
    attachments: [],
  };
});
